export * from "./QuizResultInner";
